<div class="typography typography-h1 grey-900 mb-20">
  {{ title }}
</div>
<div
  class="html-markup html-markup-l html-markup-strong-heading"
  [innerHTML]="info | safeHtml"
></div>
